'use client';

import { BanksLogosList } from '@/modules/promo/components/BanksLogosList';
import { bankLogosListConfig } from './helpers';
import { ScPaymentLogos } from './styled';

interface PaymentLogosProps {
  useSizesOnMobile?: boolean;
}

export const PaymentLogos = ({ useSizesOnMobile }: PaymentLogosProps) => {
  const { brands, srcPath } = bankLogosListConfig;
  const brandSizes = bankLogosListConfig.brandSizes as Record<
    string,
    { width: number; height: number }
  >;

  return (
    <ScPaymentLogos>
      <BanksLogosList
        brandSizes={brandSizes}
        brands={brands}
        imgSrc={(name) => `${srcPath}${name}.webp`}
        useSizesOnMobile={useSizesOnMobile}
      />
    </ScPaymentLogos>
  );
};
